import INote from "@/interfaces/Note";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DateTime } from "luxon";
import { FC } from "react";
import { Link } from "react-router-dom";

interface IProps {
  note: INote;
}

const Note: FC<IProps> = ({ note }) => {
  return (
    <div>
      <FontAwesomeIcon
        icon={faClock}
        className="text-primary me-2"
        size={"xs"}
      />
      <span className="text-600">
        {DateTime.fromISO(note.createdAt)
          .setLocale("fr")
          .toFormat("dd LLL yyyy")}
      </span>
      <span className="text-500"> à </span>
      <span className="text-600">
        {DateTime.fromISO(note.createdAt).setLocale("fr").toFormat("HH:mm")}
      </span>
      <span className="text-500"> par </span>
      {note.author ? (
        <Link to={`/users/${note.authorId}`} className="text-600">
          {note.author.fullname}
        </Link>
      ) : (
        <span className="text-600">Inconnu</span>
      )}
      <p
        className="mb-0 mt-x1 mt-md-4 mt-xl-x1 mt-xxl-2 pt-x1 pt-md-0 pt-xl-x1 pt-xxl-0"
        style={{ whiteSpace: "normal" }}
      >
        {note.message}
      </p>
    </div>
  );
};

export default Note;
